import React from 'react';

export const DeleteInfoAnalyte = () => {
    return <div></div>;
};
